"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var _react = require("@emotion/react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const _controlBg = 'rgba(0, 0, 0, 0.5)';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1ezukv3",
  styles: "min-width:50vw;min-height:50vh;cursor:zoom-out"
} : {
  name: "z84szd-imageContainer",
  styles: "min-width:50vw;min-height:50vh;cursor:zoom-out;label:imageContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const styles = exports.styles = {
  overlay: process.env.NODE_ENV === "production" ? {
    name: "1ked4ob",
    styles: "position:fixed;-webkit-overflow-scrolling:touch;top:0;left:0;right:0;bottom:0;z-index:1001;padding:1em;background:rgba(0, 0, 0, 0.8);overflow:auto;display:flex;justify-content:center;align-items:center"
  } : {
    name: "2usvsy-overlay",
    styles: "position:fixed;-webkit-overflow-scrolling:touch;top:0;left:0;right:0;bottom:0;z-index:1001;padding:1em;background:rgba(0, 0, 0, 0.8);overflow:auto;display:flex;justify-content:center;align-items:center;label:overlay;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  carousel: process.env.NODE_ENV === "production" ? {
    name: "1cx7q4s",
    styles: "position:relative;display:flex;height:100%;width:100%;.slider-container{height:100%;width:100%;}.slider-frame{height:100%!important;}.slider-list{height:100%;}.slide{height:100%!important;}"
  } : {
    name: "i05i4-carousel",
    styles: "position:relative;display:flex;height:100%;width:100%;.slider-container{height:100%;width:100%;}.slider-frame{height:100%!important;}.slider-list{height:100%;}.slide{height:100%!important;};label:carousel;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  imageContainer: zoomed => /*#__PURE__*/(0, _react.css)("display:flex;justify-content:center;align-items:center;height:100%;img{max-width:100%;max-height:100%;width:fit-content;height:fit-content;min-width:100px;min-height:100px;cursor:zoom-in;transition:min-width 50ms ease;", zoomed && _ref, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:imageContainer;")),
  controlBtn: direction => /*#__PURE__*/(0, _react.css)("background-color:", _controlBg, ";border:none;border-radius:50%;padding:0.75em;cursor:pointer;margin-left:", direction === 'left' ? '3px' : '0', ";margin-right:", direction === 'right' ? '3px' : '0', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:controlBtn;")),
  pageInfo: /*#__PURE__*/(0, _react.css)("display:flex;justify-content:center;padding:0.25em 1em;border-radius:5px;background-color:", _controlBg, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:pageInfo;")),
  closeBtn: theme => /*#__PURE__*/(0, _react.css)("background-color:", _controlBg, ";border:none;border-radius:", theme.mypageBoxBorderRadius, ";padding:0.75em;cursor:pointer;" + (process.env.NODE_ENV === "production" ? "" : ";label:closeBtn;"))
};